import React from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#fff",
        fontFamily: "'Inter', sans-serif",
        color: "#111",
      }}
    >
      {/* Top bar */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "16px clamp(20px, 5vw, 40px)",
          borderBottom: "1px solid #eee",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <button
          onClick={() => window.history.length > 1 ? navigate(-1) : navigate("/")}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: 500,
            color: "#555",
          }}
        >
          <FiArrowLeft size={18} />
          Back
        </button>
        <div style={{ fontWeight: 800, fontSize: "18px", letterSpacing: "-0.02em" }}>
          scribbledraw.
        </div>
      </div>

      <div
        style={{
          maxWidth: "560px",
          margin: "0 auto",
          padding: "48px clamp(20px, 5vw, 40px)",
        }}
      >
        <h1
          style={{
            fontSize: "32px",
            fontWeight: 800,
            letterSpacing: "-0.02em",
            marginBottom: "8px",
          }}
        >
          Terms of Service
        </h1>
        <p style={{ color: "#888", fontSize: "14px", marginBottom: "36px" }}>
          Last updated: February 2026
        </p>

        <Section title="The Service">
          <p>
            scribbledraw is an AI-powered tool that transforms hand-drawn
            sketches into polished digital assets. By using the service, you
            agree to these terms.
          </p>
        </Section>

        <Section title="Credits and Payments">
          <p>
            Generations require credits. Credits are purchased through Stripe and
            are non-refundable except where required by law. If a generation
            fails due to a system error, credits are automatically refunded.
          </p>
        </Section>

        <Section title="Content Ownership">
          <p>
            You retain full ownership of your sketches and the assets generated
            from them. scribbledraw claims no rights over your content. You are
            free to use generated assets for any personal or commercial purpose.
          </p>
        </Section>

        <Section title="Data Retention">
          <p>
            Uploaded sketches and generated images are stored for{" "}
            <strong>24 hours only</strong> and are then automatically and
            permanently deleted. It is your responsibility to download any assets
            you wish to keep before they are removed.
          </p>
        </Section>

        <Section title="Acceptable Use">
          <p>You agree not to:</p>
          <ul>
            <li>Use the service to generate illegal or harmful content.</li>
            <li>Attempt to abuse, overload, or interfere with the service.</li>
            <li>
              Circumvent rate limits or credit requirements through automated
              means.
            </li>
          </ul>
          <p>
            We reserve the right to suspend accounts that violate these terms.
          </p>
        </Section>

        <Section title="Availability">
          <p>
            scribbledraw is provided "as is" without guarantees of uptime or
            availability. We may modify, suspend, or discontinue the service at
            any time.
          </p>
        </Section>

        <Section title="Limitation of Liability">
          <p>
            To the maximum extent permitted by law, scribbledraw is not liable
            for any indirect, incidental, or consequential damages arising from
            your use of the service, including loss of data or generated content.
          </p>
        </Section>

        <Section title="Contact">
          <p>
            Questions about these terms? Reach out at{" "}
            <a
              href="mailto:candywrapperco@gmail.com"
              style={{ color: "#111", fontWeight: 500 }}
            >
              candywrapperco@gmail.com
            </a>
            .
          </p>
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: "28px" }}>
      <h2
        style={{
          fontSize: "17px",
          fontWeight: 700,
          marginBottom: "8px",
        }}
      >
        {title}
      </h2>
      <div
        style={{
          fontSize: "14px",
          color: "#555",
          lineHeight: 1.7,
        }}
      >
        {children}
      </div>
      <style>{`
        div ul { padding-left: 20px; margin: 8px 0; }
        div li { margin-bottom: 6px; }
      `}</style>
    </div>
  );
}
